module.exports = __webpack_public_path__ + "static/media/loading.d0c07738.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/loading.gif
// module id = 253
// module chunks = 0